const initialState = {
    message: undefined,
    form: {}
};

function devicesReducer(state = initialState, action = {}) {
    switch (action.type) {
        default:
            return state;
    }
}

export default devicesReducer;
